<div class="step-indicator" *ngIf="displayIndicator">
	<ul class="steps">
		<li *ngFor="let step of stepIndicators"  [class.step-on]="step.path==currentStep" [class.step-done]="step.isVisited">
			<div class="step-text"  attr.data-sm-text="Step {{step.stepNumber}} of {{stepIndicators.length}}:" attr.data-large-text="{{step.stepNumber}}. "> {{step.label}} <span *ngIf="step.path==currentStep" class="sr-only">Currently Active</span> </div>
		</li>
	</ul>
</div>
